import { render } from "./PendingPaymentList.vue?vue&type=template&id=eb160d8e&scoped=true"
import script from "./PendingPaymentList.vue?vue&type=script&lang=js"
export * from "./PendingPaymentList.vue?vue&type=script&lang=js"

import "./PendingPaymentList.vue?vue&type=style&index=0&id=eb160d8e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb160d8e"]])

export default __exports__